module.exports = __webpack_public_path__ + "static/media/line.5665d4ea.svg";